import { TooltipContentUtil } from 'wni-portals-tooltip';
import CEPATooltipUtil from './CEPATooltipUtil';

const CETooltipContentUtil = {
    ...TooltipContentUtil,
    ...CEPATooltipUtil
}

export default CETooltipContentUtil
